import { render } from "./my.vue?vue&type=template&id=e4d46bf8&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"

import "./my.vue?vue&type=style&index=0&id=e4d46bf8&scoped=true&lang=css"

import exportComponent from "E:\\pay\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d46bf8"]])

export default __exports__